import { SubscriptionTier } from 'types';

export function toRawUsageQuantity(totalUsage: number, unit: string): number {
    if (unit === 'minutes') {
        return totalUsage * 60;
    }
    return totalUsage;
}

export function getTierBandUsage(
    totalUsageRaw: number,
    tierIndex: number,
    tiers: SubscriptionTier[],
): number {
    const previousCeiling = tierIndex === 0 ? 0 : (tiers[tierIndex - 1].up_to ?? 0);
    const currentCeiling = tiers[tierIndex].up_to;

    if (totalUsageRaw <= previousCeiling) {
        return 0;
    }

    if (currentCeiling == null) {
        return totalUsageRaw - previousCeiling;
    }

    return Math.min(totalUsageRaw, currentCeiling) - previousCeiling;
}

export function getTierBandUsageDisplay(
    totalUsage: number,
    tierIndex: number,
    tiers: SubscriptionTier[],
    unit: string,
): number {
    const bandUsageRaw = getTierBandUsage(
        toRawUsageQuantity(totalUsage, unit),
        tierIndex,
        tiers,
    );

    if (bandUsageRaw <= 0) {
        return 0;
    }

    if (unit === 'minutes') {
        return Math.round(bandUsageRaw / 60);
    }

    return bandUsageRaw;
}

export function getTierAmountCents(
    tier: SubscriptionTier,
    tierIndex: number,
    tiers: SubscriptionTier[],
    unit: string,
    totalUsage: number,
): number {
    if (tier.flat_amount_decimal || tier.flat_amount) {
        const rawAmount = tier.flat_amount_decimal ?? tier.flat_amount;
        return rawAmount != null ? Number(rawAmount) : 0;
    }

    const bandUsage = getTierBandUsage(
        toRawUsageQuantity(totalUsage, unit),
        tierIndex,
        tiers,
    );

    if (bandUsage <= 0) {
        return 0;
    }

    const unitPrice = tier.unit_amount_decimal ?? tier.unit_amount;
    if (unitPrice == null) {
        return 0;
    }

    return bandUsage * Number(unitPrice);
}
